// @ts-ignore
export module NotifActionTypes {
  export enum NotifActionType {
    CUSTOMER_CUSTOMER_CREATE = 'CUSTOMER_CUSTOMER_CREATE',
    CUSTOMER_CUSTOMER_UPDATE = 'CUSTOMER_CUSTOMER_UPDATE',
    CUSTOMER_CUSTOMER_DELETE = 'CUSTOMER_CUSTOMER_DELETE',
    CUSTOMER_ACCOUNT_DEF_CREATE = 'CUSTOMER_ACCOUNT_DEF_CREATE',
    CUSTOMER_ACCOUNT_DEF_UPDATE = 'CUSTOMER_ACCOUNT_DEF_UPDATE',
    CUSTOMER_ACCOUNT_DEF_DELETE = 'CUSTOMER_ACCOUNT_DEF_DELETE',
    CUSTOMER_TRADER_CREATE = 'CUSTOMER_TRADER_CREATE',
    CUSTOMER_TRADER_UPDATE = 'CUSTOMER_TRADER_UPDATE',
    CUSTOMER_TRADER_DELETE = 'CUSTOMER_TRADER_DELETE',
  }
}


